/* CS v37 (31 Oct 2026): product page layout helpers, loaded by sections/cs-pdp-rail.liquid.
   1. Panels: every lower section with a heading (and each [data-cs-panel] block) is a panel.
   2. Wide screens: "On this page" in the side rail lists the panels and marks the one in view.
   3. Phones (749 px and narrower): each panel becomes a one-tap section. Its heading becomes the button, with a
      count where it helps ("Questions (5)"). Content stays in the page, hidden until opened.
   4. Links to a panel (On this page, "Read more", "See the order terms") open it first.
   Without this script every panel stays open, as on a wide screen. */
(function () {
  var main = document.getElementById('MainContent');
  if (!main || !main.querySelector('.cs-rail')) return;
  var lang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase().slice(0, 2);
  var phone = window.matchMedia('(max-width: 749px)').matches;

  var terms = main.querySelector('.cs-terms');
  if (terms && !terms.id) terms.id = 'cs-terms-anchor';
  else if (terms) { var ta = document.createElement('span'); ta.id = 'cs-terms-anchor'; terms.parentNode.insertBefore(ta, terms); }

  var panels = [];
  [].slice.call(main.children).forEach(function (s) {
    if (!s.classList || !s.classList.contains('shopify-section')) return;
    if (/__(main|structured-data|rail)$/.test(s.id)) return;
    if (s.querySelector('[data-cs-nopanel]')) return;
    if (s.querySelector('.cs-mobilebar, #cs-mobilebar') && !s.querySelector('h2')) return;
    var inner = s.querySelectorAll('[data-cs-panel]');
    if (inner.length) { [].forEach.call(inner, function (p) { panels.push(p); }); return; }
    if (!s.offsetHeight) return;
    var h = s.querySelector('h2') || s.querySelector('h3');
    if (!h) return;
    s.setAttribute('data-cs-panel', '');
    panels.push(s);
  });

  function heading(p) { return p.querySelector('h2') || p.querySelector('h3'); }
  function label(p) {
    var h = heading(p); if (!h) return '';
    var l = (h.getAttribute('data-nav-label') || '').trim();
    if (l) return l;
    var t = h.textContent.replace(/\s+/g, ' ').trim();
    return t.replace(/\s*\(.*?\)\s*/g, ' ').replace(/[:?].*$/, '').trim();
  }
  function count(p) {
    var c = p.getAttribute('data-cs-count');
    if (c && +c > 0) return +c;
    var d = p.querySelectorAll('details').length;
    return d > 1 ? d : 0;
  }

  panels.forEach(function (p, i) { if (!p.id) p.id = 'cs-panel-' + (i + 1); });

  // On this page
  var toc = document.getElementById('cs-rail-toc');
  if (toc) {
    toc.innerHTML = panels.map(function (p) { return '<li><a href="#' + p.id + '">' + label(p) + '</a></li>'; }).join('');
    var links = [].slice.call(toc.querySelectorAll('a'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) {
            var on = a.getAttribute('href') === '#' + e.target.id;
            a.classList.toggle('is-on', on);
            // 3 Nov 2026: on short screens the list scrolls in its own box; keep the current entry in view
            if (on && toc.scrollHeight > toc.clientHeight + 1) {
              var tr = toc.getBoundingClientRect(), ar = a.getBoundingClientRect();
              if (ar.top < tr.top || ar.bottom > tr.bottom) toc.scrollTop += ar.top - tr.top - tr.height / 3;
            }
          });
        });
      }, { rootMargin: '-30% 0px -65% 0px', threshold: 0 });
      panels.forEach(function (p) { io.observe(p); });
    }
  }

  // Phones: one-tap panels
  if (phone) {
    panels.forEach(function (p) {
      var h = heading(p); if (!h) return;
      var text = h.textContent.replace(/\s+/g, ' ').trim();
      var n = count(p);
      var head = document.createElement('div');
      head.className = 'cs-acc__head';
      h.textContent = '';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cs-acc__btn';
      b.setAttribute('aria-expanded', 'false');
      b.setAttribute('aria-controls', p.id);
      b.innerHTML = '<span>' + text.replace(/</g, '&lt;') + (n ? ' <span class="cs-acc__n"><span class="cs-vh">(</span>' + n + '<span class="cs-vh">' + (lang === 'en' ? ' items)' : ' item)') + '</span></span>' : '') + '</span>';
      h.appendChild(b);
      head.appendChild(h);
      p.insertBefore(head, p.firstChild);
      p.classList.add('cs-acc');
      b.addEventListener('click', function () { setOpen(p, !p.classList.contains('is-open')); });
    });
  }

  function setOpen(p, open) {
    p.classList.toggle('is-open', open);
    var b = p.querySelector('.cs-acc__btn'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function openFor(id) {
    var t = id && document.getElementById(id); if (!t) return;
    var p = t.closest('[data-cs-panel]'); if (p && p.classList.contains('cs-acc')) setOpen(p, true);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]'); if (!a) return;
    openFor(decodeURIComponent(a.getAttribute('href').slice(1)));
  });
  if (location.hash) openFor(decodeURIComponent(location.hash.slice(1)));
})();
